import { Link } from 'react-router-dom';
import { useSettings, useUpdateSettings } from '../api/hooks';
import { useAuth } from '../auth/AuthProvider';

export function SettingsScreen() {
  const { session, signOut } = useAuth();
  const settings = useSettings();
  const update = useUpdateSettings();

  const cycleStartDay = settings.data?.cycleStartDay ?? 1;

  return (
    <div className="flex flex-col gap-6 px-5 pt-4">
      <h1 className="text-xl font-semibold">Réglages</h1>

      <section className="rounded-2xl border border-line bg-surface p-4">
        <label className="flex flex-col gap-1.5">
          <span className="text-sm">Jour de début du cycle</span>
          <select
            value={cycleStartDay}
            onChange={(event) => update.mutate({ cycleStartDay: Number(event.target.value) })}
            className="rounded-xl border border-line bg-plane px-4 py-3 text-base"
          >
            {Array.from({ length: 28 }, (_, index) => index + 1).map((day) => (
              <option key={day} value={day}>
                le {day}
              </option>
            ))}
          </select>
          <span className="text-xs text-ink-muted">
            Choisissez le jour de votre salaire pour que le cycle colle à votre mois réel. Limité au
            28 : un cycle commençant le 30 n’aurait pas de premier jour en février.
          </span>
        </label>
      </section>

      <Link
        to="/comptes"
        className="flex items-center justify-between rounded-2xl border border-line bg-surface p-4 text-sm"
      >
        Comptes et soldes
        <span aria-hidden="true" className="text-ink-muted">
          ›
        </span>
      </Link>

      <section className="rounded-2xl border border-line bg-surface p-4">
        <p className="text-sm">Cet appareil</p>
        <p className="mt-1 text-sm text-ink-secondary">{session?.device.name}</p>
        <p className="mt-2 text-xs text-ink-muted">
          Son nom pré-remplit « payé par » sur chaque saisie.
        </p>
      </section>

      <section className="rounded-2xl border border-line bg-surface p-4">
        <p className="text-sm">Compte</p>
        <p className="mt-1 text-sm text-ink-secondary">{session?.user.email}</p>
        <button
          type="button"
          onClick={() => void signOut()}
          className="mt-3 w-full rounded-xl border border-line py-3 text-sm text-critical"
        >
          Se déconnecter
        </button>
      </section>
    </div>
  );
}
